module.exports = "<div bind-html-compile=\"vm.content\"></div>\r\n";